var map = {
	"./aparthotelclub/ic_tag_event_type.png": 7883,
	"./beachful/ic_tag_event_type.png": 24578,
	"./castlepedia/ic_tag_event_type.png": 66894,
	"./cocktayl/ic_tag_event_type.png": 4908,
	"./ic_tag_event_type.png": 2987,
	"./luxresortclub/ic_tag_event_type.png": 57350,
	"./parkful/ic_tag_event_type.png": 49467,
	"./prefabworld/ic_tag_event_type.png": 5531,
	"./rooftopclub/ic_tag_event_type.png": 51473,
	"./spaclub/ic_tag_event_type.png": 91243,
	"./worldcasino/ic_tag_event_type.png": 35974,
	"./zoopedia/ic_tag_event_type.png": 21849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13577;